import * as React from "react"
import { initializeActivity, setActivityContext, trackActivity } from "../activity"
import { PRODUCT_CATALOG } from "../catalogue"
import type { useCheckoutModel } from "./useCheckoutModel"
import type { useCheckoutState } from "./useCheckoutState"

type Inputs = Pick<ReturnType<typeof useCheckoutModel>,
    "baseUrl" | "workflowStep">
    & Pick<ReturnType<typeof useCheckoutState>,
        "activeSlug" | "product">

export function useCheckoutAnalytics(inputs: Inputs) {
    const {
        baseUrl,
        activeSlug,
        product,
        workflowStep,
    } = inputs
    React.useEffect(() => { initializeActivity(baseUrl) }, [baseUrl])
    const analytics = React.useCallback((name: string, extra: Record<string, unknown> = {}) => {
        const selected = PRODUCT_CATALOG.find(item => item.slug === activeSlug)
        setActivityContext({ type: selected?.type, sku: selected?.sku, name: selected?.name })
        const names: Record<string, Parameters<typeof trackActivity>[0]> = { hire_booking_viewed: "product_viewed", hire_dates_selected: "dates_completed", hire_availability_checked: "availability_checked", hire_addons_viewed: "addons_viewed", hire_addon_added: "addons_changed", hire_addon_removed: "addons_changed", hire_addon_images_viewed: "addons_viewed" }
        const event = names[name]
        if (event) trackActivity(event, { ...extra, ...(extra.availability_result ? { result: extra.availability_result } : {}) }, event === "product_viewed")
    }, [activeSlug])

    React.useEffect(() => {
        const selected = PRODUCT_CATALOG.find(item => item.slug === activeSlug)
        setActivityContext({ type: selected?.type, sku: selected?.sku, name: product?.name, stage: workflowStep })
        if (workflowStep === "payment") trackActivity("details_viewed", {}, true)
        if (workflowStep === "payment") trackActivity("payment_viewed", {}, true)
    }, [workflowStep, activeSlug, product?.name])
    const lastTrackedProduct = React.useRef("")
    React.useEffect(() => {
        if (lastTrackedProduct.current && lastTrackedProduct.current !== activeSlug) trackActivity("product_changed")
        lastTrackedProduct.current = activeSlug
    }, [activeSlug])

    return {
        analytics,
    }
}
